export interface NavLink {
  label: string
  href: string
}

export interface Pillar {
  index: string
  title: string
  body: string
}

export interface SceneMeta {
  id: string
  label: string
}

export const brand = {
  name: 'WABASH & ROAST',
  eyebrow: "Terre Haute's Premier Culinary Destination",
  social: '@WABASHANDROAST',
  copyright: '© 2024 WABASH & ROAST — TERRE HAUTE, IN'
}

export const navLinks: NavLink[] = [
  { label: 'Menu', href: '#kitchen' },
  { label: 'Kitchen', href: '#kitchen' },
  { label: 'Coffee', href: '#coffee' },
  { label: 'Visit', href: '#visit' }
]

export const scenes: SceneMeta[] = [
  { id: 'ritual', label: 'The Ritual' },
  { id: 'philosophy', label: 'Philosophy' },
  { id: 'kitchen', label: 'The Kitchen' },
  { id: 'coffee', label: 'The Coffee' },
  { id: 'visit', label: 'Visit' },
  { id: 'map', label: 'The Corner' }
]

export const pillars: Pillar[] = [
  {
    index: '01',
    title: 'THE ROAST',
    body: 'Ethically sourced beans, hand-crafted by Yaggy Road. Precision in every drop.'
  },
  {
    index: '02',
    title: 'THE KITCHEN',
    body: 'Not "cafe food," but Chef-led creations made from scratch with local ingredients.'
  },
  {
    index: '03',
    title: 'THE SPACE',
    body: 'A curated environment designed for connection, creativity, and comfort.'
  }
]

export const visitInfo = {
  location: ['663 Wabash Ave,', 'Terre Haute, IN'],
  hours: ['Mon–Fri 7am—4pm', 'Sat–Sun 8am—3pm'],
  address: '663 Wabash Ave, Terre Haute, IN 47807',
  coordinates: { lat: 39.4668, lng: -87.4094 },
  crossStreet: 'At the corner of 7th & Wabash, downtown Terre Haute.',
  directionsUrl:
    'https://www.google.com/maps/search/?api=1&query=663+Wabash+Ave+Terre+Haute+IN'
}

export const imagery = {
  hero:
    'https://cdn.magicpatterns.com/patterns/generated-images/775a47c1-a1c9-4b57-ad8b-0214a0ceb1fd.jpg',
  space:
    'https://cdn.magicpatterns.com/patterns/generated-images/dabc3d23-ea8c-4e38-945d-84f8ca9ebb7e.jpg',
  food:
    'https://cdn.magicpatterns.com/patterns/generated-images/96d60a32-8820-4389-93b6-32c041095803.jpg',
  coffee:
    'https://cdn.magicpatterns.com/patterns/generated-images/95561bf8-3042-483f-9c3b-80c49790ed64.jpg',
  visit:
    'https://cdn.magicpatterns.com/patterns/generated-images/f56e4ea3-8546-4ed4-9f14-80a872305cd8.jpg'
}
